import { connect } from 'react-redux';
import { getAmountUnit } from 'state/secondaryMarket/cpOrder/cpOrder.utils';
import { liveSelectors } from 'state/secondaryMarket/live/live.selector';
import { liveThunks } from 'state/secondaryMarket/live/live.thunk';
import { liveReferentialSelectors } from 'state/secondaryMarket/live/referential/liveReferential.selector';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import { getTabIsFrozen } from 'state/workspaces/tabs/tabs.selector';

type SalesMarginInformationOwnProps = {
  tabId: string;
  className?: string;
};
type SalesMarginInformationStateProps = {
  upfront: number | undefined;
  upFrontReadOnly?: boolean;
  salesMarginAdjusted: number | undefined;
  tradingPriceAdjusted: number | undefined;
  amountUnit: string;
  isFrozen: boolean;
};
type SalesMarginInformationDispatchProps = {
  onTradingPriceChanged: (value: number | undefined) => void;
  onSalesMarginChanged: (value: number | undefined) => void;
  onUpFrontChanged: (value: number | undefined) => void;
};

export type SalesMarginInformationProps = SalesMarginInformationDispatchProps &
  SalesMarginInformationOwnProps &
  SalesMarginInformationStateProps;

export const mapStateToProps = (
  state: AppState,
  { tabId }: SalesMarginInformationOwnProps,
): SalesMarginInformationStateProps => {
  const priceType = liveReferentialSelectors.getPriceType(state, tabId)!;

  const currency = liveReferentialSelectors.getCurrency(state, tabId);
  const amountUnit = getAmountUnit(priceType, currency!);
  const upfront = liveSelectors.getFormUpfrontFormatted(state, tabId);
  const salesMarginAdjusted = liveSelectors.getFormCustomizedXMarginAdjustmentFormatted(state, tabId);
  const tradingPriceAdjusted = liveSelectors.getFormCustomizedTradingPriceAdjustmentFormatted(state, tabId);

  const isFrozen = getTabIsFrozen(state, tabId) ?? false;

  return {
    amountUnit,
    upfront,
    salesMarginAdjusted,
    tradingPriceAdjusted,
    isFrozen,
  };
};

export const mapDispatchToProps = (
  dispatch: ThunkDispatch,
  { tabId }: SalesMarginInformationOwnProps,
): SalesMarginInformationDispatchProps => {
  return {
    onTradingPriceChanged: value => {
      dispatch(liveThunks.percentFieldChangedThunk(tabId, 'customizedTradingPriceAdjustment', value));
    },
    onSalesMarginChanged: value => {
      dispatch(liveThunks.percentFieldChangedThunk(tabId, 'customizedXMarginAdjustment', value));
    },
    onUpFrontChanged: value => {
      dispatch(liveThunks.percentFieldChangedThunk(tabId, 'customizedUpfront', value));
    },
  };
};

export const connectLiveSalesMarginInformation = connect(mapStateToProps, mapDispatchToProps);
